exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".faq-section[data-v-7ee42b90]{margin-bottom:2rem}.faq-section i.fas[data-v-7ee42b90]{transition:transform .25s,color .25s}.faq-section .faq-section-item__answer[data-v-7ee42b90]{overflow:hidden;font-size:14px;opacity:.8;transition:max-height .25s,padding-top .25s,padding-bottom .25s}.faq-section .faq-section-item__answer p[data-v-7ee42b90]{transition:opacity .25s;opacity:0}.faq-section .faq-section-item__answer--open p[data-v-7ee42b90]{opacity:1}.rotate-90[data-v-7ee42b90]{transform:rotate(90deg)}", ""]);

// exports
